// 后端基础地址
const BASE_URL = 'https://web.xinghan.icu'

// 通用请求方法
async function request(url, options = {}) {
  const token = localStorage.getItem('token')
  
  try {
    const response = await fetch(BASE_URL + url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'token': token }),
        ...options.headers
      }
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error('请求失败:', error)
    throw error
  }
}

// 获取轮播图列表
export async function getBannerList(params = {}) {
  const { page = 1, limit = 10, status = 'normal' } = params
  const queryString = new URLSearchParams({ page, limit, status }).toString()
  return request(`/api/banner/index?${queryString}`)
}

// 获取商品列表
export async function getProductList(params = {}) {
  const { page = 1, limit = 10, category_id } = params
  const queryParams = { page, limit }
  if (category_id) {
    queryParams.category_id = category_id
  }
  const queryString = new URLSearchParams(queryParams).toString()
  return request(`/api/shopitem/index?${queryString}`)
}

// 获取网站配置
export const getSiteConfig = () => {
  return request('/api/siteconfig/index')
}

// 获取所有分类及其商品
export const getAllCategories = () => {
  return request('/api/productcategory/index')
}

// 获取单个分类的所有商品
export const getCategoryGoods = (id) => {
  return request(`/api/productcategory/goods?id=${id}`)
}

// 用户注册
export const userRegister = (data) => {
  return request('/api/user/register', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

// 用户登录
export const userLogin = (data) => {
  return request('/api/user/login', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

// 获取个人信息
export const getUserInfo = (token) => {
  return request('/api/user/index', {
    headers: {
      'token': token
    }
  })
}

// 退出登录
export const userLogout = (token) => {
  return request('/api/user/logout', {
    method: 'POST',
    headers: {
      'token': token
    }
  })
}

// 获取商品详情
export const getProductDetail = (id) => {
  return request(`/api/shopitem/detail?id=${id}`)
}

// ==================== 购物车API ====================
// 获取购物车列表
export const getCartList = (token) => {
  return request('/api/cart/index', {
    headers: {
      'token': token
    }
  })
}

// 添加到购物车
export const addToCart = (data, token) => {
  return request('/api/cart/add', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// 更新购物车数量
export const updateCart = (data, token) => {
  return request('/api/cart/update', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// 删除购物车商品
export const deleteCart = (data, token) => {
  return request('/api/cart/delete', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// 清空购物车
export const clearCart = (token) => {
  return request('/api/cart/clear', {
    method: 'POST',
    headers: {
      'token': token
    }
  })
}

// ==================== 订单API ====================
// 创建订单（购物车结算）
export const createOrder = (data, token) => {
  return request('/api/order/create', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// 立即购买
export const buyNow = (data, token) => {
  return request('/api/order/buy', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// 我的订单列表
export const getMyOrders = (params, token) => {
  const query = new URLSearchParams(params).toString()
  return request(`/api/order/mylist?${query}`, {
    headers: {
      'token': token
    }
  })
}

// 订单详情
export const getOrderDetail = (id, token) => {
  return request(`/api/order/detail?id=${id}`, {
    headers: {
      'token': token
    }
  })
}

// 取消订单
export const cancelOrder = (data, token) => {
  return request('/api/order/cancel', {
    method: 'POST',
    headers: {
      'token': token
    },
    body: JSON.stringify(data)
  })
}

// ==================== 页面内容API ====================
// 获取页面详情
export const getPageDetail = (type) => {
  return request(`/api/page/detail?type=${type}`)
}

// ==================== 文章分类API ====================
// 获取文章分类列表
export const getArticleCategories = () => {
  return request('/api/articlecategory/index')
}

// ==================== 文章API ====================
// 获取文章列表
export const getArticleList = (params) => {
  const query = new URLSearchParams(params).toString()
  return request(`/api/article/index?${query}`)
}

// 获取文章详情
export const getArticleDetail = (id) => {
  return request(`/api/article/detail?id=${id}`)
}

// ==================== 信息发布API ====================
// 发布信息
export const publishInfo = (data) => {
  return request('/api/infopost/add', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

// 获取我的信息列表
export const getMyInfoList = (params) => {
  const query = new URLSearchParams(params).toString()
  return request(`/api/infopost/mylist?${query}`)
}

// ==================== 订单API ====================
// 获取订单列表
export const getOrderList = (params) => {
  const query = new URLSearchParams(params).toString()
  return request(`/api/order/mylist?${query}`)
}

// ==================== 文件上传API ====================
// 上传文件
export const uploadFile = async (formData) => {
  const token = localStorage.getItem('token')
  
  try {
    const response = await fetch(BASE_URL + '/api/common/upload', {
      method: 'POST',
      headers: {
        'token': token || ''
      },
      body: formData
    })
    const data = await response.json()
    return data
  } catch (error) {
    console.error('上传失败:', error)
    throw error
  }
}
